import { query } from '../../network/fetch.js'
import {
    addCourseToStudents,
    getStudentParamList,
    removeStudents,
    resetStudentsTokens,
    addStudentsToEvent,
    addStudentsToTeam
} from '../../network/queries/students'
import Student from '../models/Student'
import {
    STUDENT_LIST,
    STUDENT_LIST_REQUEST,
    STUDENT_LIST_CLEAR,
    BULK_STUDENT_LIST_ADD,
    BULK_STUDENT_LIST_REMOVE,
    BULK_STUDENT_LIST_CLEAR
} from '../types'

const state = {
    isFetching: false,
    per_page: 25,
    total: 0,
    items: [],
    fetchKey: '',
    bulkStudents: []
}

const actions = {
    
    async getStudents ({ commit }, variables) {
        const { data, raw } = await Student.$fetchAll(variables)
        commit(STUDENT_LIST, { total: raw.total, data})
        return data
    },

    getStudentParamList (_, params) {
        params = params || {}
        return new Promise((resolve) => {
            query({
                query: getStudentParamList,
                variables: {
                    query: params.query,
                    per_page: params.per_page || 99999,
                    relation: params.relation,
                    relationUuid: params.relationUuid
                }
            }).then( ({ data }) => {
                Student.insert({data: data.students.data})
                resolve(data.students.data)
            })
        })
    },
    addCourseToStudents ({ commit }, courseId) {
        return new Promise(resolve => {
            query({
                query: addCourseToStudents,
                variables: {
                    student_ids: state.bulkStudents,
                    course_id: courseId
                }
            }).then( () => {
                commit(BULK_STUDENT_LIST_CLEAR)
                resolve()
            })
        })
    },
    addStudentsToEvent ({ commit }, eventId) {
        return new Promise(resolve => {
            query({
                query: addStudentsToEvent,
                variables: {
                    student_ids: state.bulkStudents,
                    event_id: eventId
                }
            }).then( () => {
                commit(BULK_STUDENT_LIST_CLEAR)
                resolve()
            })
        })
    },
    addStudentsToTeam ({ commit }, teamId) {
        return new Promise((resolve) => {
            query({
                query: addStudentsToTeam,
                variables: {
                    student_ids: state.bulkStudents,
                    team_id: teamId
                }
            }).then( () => {
                commit(BULK_STUDENT_LIST_CLEAR)
                resolve()
            })
        })
    },
    removeStudents ({ commit }) {
        return new Promise((resolve) => {
            query({
                query: removeStudents,
                variables: {
                    student_ids: state.bulkStudents
                }
            }).then( () => {
                commit(BULK_STUDENT_LIST_CLEAR)
                resolve()
            })
        })
    },
    resetStudentsTokens ({ commit }) {
        return new Promise((resolve) => {
            query({
                query: resetStudentsTokens,
                variables: {
                    student_ids: state.bulkStudents
                }
            }).then( () => {
                commit(BULK_STUDENT_LIST_CLEAR)
                resolve()
            })
        })
    }
}

const mutations = {
    [STUDENT_LIST_CLEAR](state, params) {
        const key = 'key' + params.relation + params.relationUuid
        if (state.fetchKey != key) {
            state.items = []
            state.fetchKey = key
        }
    },
    [STUDENT_LIST_REQUEST](state) {
        state.isFetching = true
    },
    [STUDENT_LIST](state, { data, total}) {
        // state.isFetching = false
        state.items = data
        state.total = total
    },
    [BULK_STUDENT_LIST_ADD](state, studentId) {
        state.bulkStudents.push(studentId)
    },
    [BULK_STUDENT_LIST_REMOVE](state, index) {
        state.bulkStudents.splice(index, 1)
    },
    [BULK_STUDENT_LIST_CLEAR](state) {
        state.bulkStudents = []
    }
}

export default {
    state,
    actions,
    mutations
}
